export enum DocsRequirement {
  // DOCUMENTOS REGISTRO
  CartaSolicitud = 26,
  ActaConstitucion = 27,
  EstatutosEntidad = 28,
  Convocatoria = 30,
  Certificacion = 31,
  Certificacion2 = 32,
}
